import { type QueryKey, useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import type { HTTPResponse, ProblemResponse } from "@/lib/http/useHTTP";

export type UseHTTPQueryOptions<T> = Omit<UseQueryOptions<T, ProblemResponse, T, QueryKey>, "queryFn"> & {
	queryFn: () => Promise<HTTPResponse<T>>;
};

export const useHTTPQuery = <T>(options: UseHTTPQueryOptions<T>): UseQueryResult<T, ProblemResponse> => useQuery({
	...options,
	queryFn: async () => {
		const response = await options.queryFn();
		return response.body;
	}
});
